import {
  Component, OnInit, ChangeDetectionStrategy,
} from '@angular/core';
import { StateService } from '@uirouter/core';

interface EmojiData {
  shortname: string;
  category: string;
  tone?: string;
}

@Component({
  selector: 'ut-emoji',
  templateUrl: './emoji.component.html',
  styleUrls: ['./emoji.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmojiComponent implements OnInit {
  emojiByCategory: { [key: string]: EmojiData[] } = {};
  tones: string[] = [];
  activeTone: string = '';

  constructor(
    private $state: StateService,
  ) {}

  ngOnInit(): void {
    // Data will be loaded via route resolve
    // and accessed through transition params

    // Redirect to default category if on parent state
    if (this.$state.current.name === 'emoji') {
      this.$state.go('emoji.category', { category: 'people' }, { location: 'replace' });
    }
  }

  setActiveTone(tone: string): void {
    this.activeTone = tone;
  }
}
